import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useIsDesktop } from '../../utils/mediaQueries';
import styles from './styles';
export const Carousel = ({ children, activeIndex, setActiveIndex }) => {
    const childrenArray = React.Children.toArray(children);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);
    const carouselRef = useRef(null);
    const isDesktop = useIsDesktop();
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchEndX.current = e.touches[0].clientX;
    };
    const handleTouchMove = (e) => {
        e.preventDefault();
        touchEndX.current = e.touches[0].clientX;
    };
    const handleTouchEnd = () => {
        if (touchStartX.current - touchEndX.current > 50) {
            // Swiped left
            setActiveIndex((activeIndex + 1) % childrenArray.length);
        }
        if (touchStartX.current - touchEndX.current < -50) {
            // Swiped right
            setActiveIndex((activeIndex - 1 + childrenArray.length) % childrenArray.length);
        }
    };
    useEffect(() => {
        const carouselElement = carouselRef.current;
        if (carouselElement) {
            carouselElement.addEventListener('touchstart', handleTouchStart, { passive: true });
            carouselElement.addEventListener('touchmove', handleTouchMove, { passive: false });
            carouselElement.addEventListener('touchend', handleTouchEnd);
            return () => {
                carouselElement.removeEventListener('touchstart', handleTouchStart);
                carouselElement.removeEventListener('touchmove', handleTouchMove);
                carouselElement.removeEventListener('touchend', handleTouchEnd);
            };
        }
    }, [children, activeIndex]);
    return (_jsxs(Box, { ref: carouselRef, sx: styles.carouselContainer, children: [childrenArray.map((child, index) => index === activeIndex && _jsx(Box, { children: child }, index)), _jsx(Box, { sx: styles.chipContainer, children: childrenArray.map((child, index) => (_jsx("button", { style: styles.carouselChip(index === activeIndex, isDesktop), onClick: () => setActiveIndex(index) }, index))) })] }));
};
